<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_table_of_contents_1"><span>Death to Christmas Sweaters</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By LE Franks</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Chess and Benjamin are casual lovers, each hiding his devotion to the other and his wish for more. But Chess is a wealthy playboy who—Benjamin believes—will never settle down. And Chess is sure, with the way Benjamin keeps him at arm’s length, that he can’t be interested in getting serious.</p>
<p class="P_Normal">They’re destined for a head-on collision as Chess plans for a holiday escape designed to send Benjamin’s ardor spiking like the temperatures in Los Angeles, while Benjamin desperately drags his feet, wanting to cool things down to protect his vulnerable heart. But when the ghosts of Chess’s Christmas past and Benjamin’s unwelcome present converge at LAX, it’s obvious other forces are about to take over.</p>
<p class="P_Normal">Drawn into their respective family dramas at a joint gathering, will Chess and Benjamin finally take a stand for each other and the relationship they both want, or will the holiday finally take its toll?</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?42df6c31